import React from 'react';
import { motion } from 'framer-motion';
import ReferralProgress from '../components/referral/ReferralProgress';
import { ReferralStats } from '../types/ReferralTypes';
import PageWrapper from '../components/layout/PageWrapper';

const mockStats: ReferralStats = {
  totalInvites: 12,
  pendingInvites: 3,
  acceptedInvites: 9,
  totalRewards: 250,
  pendingRewards: 75,
  earnedCredits: 175,
  currentTier: 'Silver',
  progressToNextTier: 9,
  nextTierThreshold: 15
};

const ReferralDashboard: React.FC = () => {
  return (
    <PageWrapper>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-8"
      >
        <h1 className="text-3xl font-bold text-gray-900">Referral Program</h1>
        <p className="mt-2 text-lg text-gray-600">Invite friends and earn rewards together</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.1 }}
          className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100"
        >
          <h3 className="text-lg font-medium text-gray-900 mb-2">Total Earnings</h3>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-gray-900">${mockStats.earnedCredits}</span>
            <span className="ml-2 text-sm text-gray-500">earned</span>
          </div>
          <p className="mt-2 text-sm text-gray-600">
            ${mockStats.pendingRewards} pending rewards
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100"
        >
          <h3 className="text-lg font-medium text-gray-900 mb-2">Your Invites</h3>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-gray-900">{mockStats.totalInvites}</span>
            <span className="ml-2 text-sm text-gray-500">total invites</span>
          </div>
          <p className="mt-2 text-sm text-gray-600">
            {mockStats.pendingInvites} pending · {mockStats.acceptedInvites} accepted
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
          className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100"
        >
          <h3 className="text-lg font-medium text-gray-900 mb-2">Current Tier</h3>
          <div className="flex items-baseline">
            <span className="text-3xl font-bold text-gray-900">{mockStats.currentTier}</span>
            <span className="ml-2 text-sm text-gray-500">member</span>
          </div>
          <p className="mt-2 text-sm text-gray-600">
            {mockStats.nextTierThreshold - mockStats.progressToNextTier} invites to Gold tier
          </p>
        </motion.div>
      </div>

      <ReferralProgress stats={mockStats} />
    </PageWrapper>
  );
};

export default ReferralDashboard;